import { useState } from "react";
import { LiquidityCard } from "./LiquidityCard";
import { CLLiquidityCard } from "./CLLiquidityCard";
import { BinLiquidityCard } from "./BinLiquidityCard";
import { cn } from "../../lib/utils";
import { Droplets, ZoomIn, BarChart2 } from "lucide-react";

type LiqTab = "v2" | "cl" | "bin";

const TABS: Array<{ id: LiqTab; label: string; icon: typeof Droplets; description: string }> = [
  {
    id: "cl",
    label: "Infinity CL",
    icon: ZoomIn,
    description:
      "V4 Infinity — Concentrated Liquidity. Set a price range and concentrate capital for up to 4000x efficiency on active ranges.",
  },
  {
    id: "bin",
    label: "Infinity Bin",
    icon: BarChart2,
    description:
      "V4 Infinity — Liquidity Book. Extreme precision at fixed price bins. Behaves like an on-chain limit-order book.",
  },
  {
    id: "v2",
    label: "V2 AMM",
    icon: Droplets,
    description: "Classic full-range AMM — liquidity across all prices. Simple and reliable.",
  },
];

export function LiquidityPage() {
  const [tab, setTab] = useState<LiqTab>("cl");
  const activeTab = TABS.find((t) => t.id === tab)!;

  return (
    <div className="flex flex-col items-center justify-start pt-12 pb-20 px-4 min-h-[calc(100vh-4rem)]">
      <div className="text-center mb-8 max-w-xl">
        <h1 className="font-display text-3xl font-bold gradient-text mb-2">
          Provide Liquidity
        </h1>
        <p className="text-text-secondary text-sm">
          Earn trading fees on JasmyChain — V4 Infinity concentrated &amp; bin pools, plus classic V2
        </p>
      </div>

      {/* Pool type tabs */}
      <div className="w-full max-w-[540px] mb-6">
        <div className="flex gap-1 p-1 bg-surface/50 rounded-card">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={cn(
                "flex-1 flex items-center justify-center gap-1.5 py-2.5 rounded-button text-sm font-medium transition-all",
                tab === id
                  ? "bg-primary/15 text-primary"
                  : "text-text-secondary hover:text-text-primary"
              )}
            >
              <Icon className="w-4 h-4" />
              {label}
            </button>
          ))}
        </div>

        {/* Description */}
        <div className="mt-3 px-1">
          <p className="text-text-tertiary text-xs leading-relaxed">{activeTab.description}</p>
        </div>
      </div>

      {/* Card */}
      {tab === "v2" && <LiquidityCard />}
      {tab === "cl" && <CLLiquidityCard />}
      {tab === "bin" && <BinLiquidityCard />}
    </div>
  );
}
